import React, { useState, useEffect } from 'react';
import 'dayjs/locale/sv';
const OpenMessage = (props) => {
    const [message, setMessage] = useState({})
    const [quill, setQuill] = useState()
    
    useEffect(() => {
        setMessage(props.message)
    },[props])

    useEffect(() => {
        const loadQuillScript = () => {
          const scriptElement = document.createElement('script');
          scriptElement.id = 'quilly';
          scriptElement.src =
            'https://cdn.jsdelivr.net/npm/quill@2.0.0-rc.2/dist/quill.js';
          scriptElement.async = true;
          scriptElement.onload = createQuill;
          document.body.appendChild(scriptElement);
        };
    
        // Check if Quill script is already loaded
        const quillScript = document.querySelector('#quilly');
        if (!quillScript) {
          loadQuillScript();
        } else {
          createQuill();
        }
      }, []);
    
    
      const createQuill = () => {
        // Check if Quill is already initialized
        if (quill) return;
    
        // Create Quill instance
        setQuill(new window.Quill('#editor'));
        // quill = new window.Quill('#editor');
      };

      useEffect(() => {
        // Update Quill editor content when message changes
        if (message.content && quill) {
            let content = JSON.parse(message.content)
            quill.setContents(content.ops);
            quill.enable(false)
        }
      }, [message.content, quill]);

    
    return(
        <>
            <div className="p-3">
                <div className="w-100 h-100" id="editor"/>
            </div>
        </>
    )
}

export default OpenMessage;